<template>
  <div v-if="$ability.can('read', 'Sale')">
    <div v-if="loading">
      <div class="p-grid" id="loading">
        <div class="p-col-12" v-for="index in results.length || 5" :key="index">
          <Card>
            <template v-slot:content>
              <div class="p-grid">
                <div class="p-col-3" v-for="index in 8" :key="index">
                  <Skeleton width="100%" height="23px" />
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="p-grid" v-for="(sale, index) in results" :key="index">
        <div class="p-col-12">
          <router-link
            :to="{ name: 'sale.edit', params: { id: sale.id } }"
            style="text-decoration: none"
            v-if="$ability.can('write', 'Sale')"
          >
            <SaleCard :sale="sale"></SaleCard>
          </router-link>
          <SaleCard :sale="sale" v-else></SaleCard>
        </div>
      </div>
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        :rowsPerPageOptions="[20, 30, 40, 50]"
        @page="onPageChange"
      ></Paginator>
      <router-link
        :to="{ name: 'sale.create' }"
        style="text-decoration: none"
        v-if="$ability.can('write', 'Sale')"
      >
        <AppFloatButton icon="pi pi-plus" />
      </router-link>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { SaleApi } from '../../services/api';
import SaleCard from './components/SaleCard';

export default {
  name: 'SaleList',
  components: {
    SaleCard,
  },
  data() {
    return {
      loading: false,
      query: {
        pageSize: 20,
        page: 1,
      },
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
      results: [],
    };
  },
  async created() {
    await this.fetchSales();
    this.$emitter.on('topbar-search', ({ query }) => {
      const { page, pageSize } = this.query;
      this.query = { ...query, page, pageSize };
      this.fetchSales(query);
    });
  },
  methods: {
    async fetchSales() {
      try {
        this.loading = true;
        const fetchResponse = await SaleApi.fetch(this.query);
        this.results = fetchResponse.results;
        this.pagination = fetchResponse.pagination;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange({ page }) {
      this.query = { ...this.query, page: page + 1 };
      await this.fetchSales();
    },
  },
  beforeUnmount() {
    this.$emitter.off('topbar-search');
  },
};
</script>

<style scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
